module.exports = {"410782001":"城关街道","410782002":"胡桥街道","410782101":"薄壁镇","410782102":"峪河镇","410782103":"百泉镇","410782104":"孟庄镇","410782105":"常村镇","410782106":"吴村镇","410782107":"南村镇","410782108":"南寨镇","410782109":"上八里镇","410782110":"北云门镇","410782111":"占城镇","410782112":"冀屯镇","410782200":"黄水乡","410782201":"拍石头乡","410782202":"高庄乡","410782203":"张村乡","410782205":"赵固乡","410782206":"西平罗乡","410782207":"洪洲乡","410782208":"沙窑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410782.json
// module id = 1596
// module chunks = 0